import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { Popup } from 'components/UI/Popup';

import { getDefaultPopupImg } from '../../utils';

import css from './transferUserPopupDefault.module.sass';

type PropTypes = {
  onMount?: () => void;
  onClose: () => void;
  onSubmit: () => void;
};

export const TransferUserPopupDefault: React.FC<PropTypes> = ({
  onMount,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation('app');

  useEffect(() => {
    onMount && onMount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Popup popupClassName={css.popup} isIndented={false} onClose={onClose}>
      <img
        src={getDefaultPopupImg()}
        width="304"
        height="370"
        className={css.photo}
        alt=""
      />
      <div className={css.content}>
        <h2 className={css.title}>
          <Trans i18nKey="transferUserPopup.title" ns="app" />
        </h2>
        <BaseButton type={ButtonTypes.Accent} onClick={onSubmit}>
          {t('transferUserPopup.submitBtn')}
        </BaseButton>
      </div>
    </Popup>
  );
};
